import {
  DataDeclarationIcaro,
  SubjectIcaroVM,
} from 'civil-status/view-models/form-declaration-icaro';
import { DateTime } from 'luxon';
import { formatNameIcaro, formatSurnameIcaro } from '../format-surname-name-icaro';

export const transformerFather = (data: DataDeclarationIcaro): SubjectIcaroVM | undefined => {
  if (!data) {
    return undefined;
  }

  return {
    freshman: data.matricolaPadre?.toString() || '',
    numberFamily: data.numeroFamigliaPadre?.toString() || '',
    surname: formatSurnameIcaro(data.cognomeNomePadre),
    name: formatNameIcaro(data.cognomeNomePadre),
    dateBorn: data.dataNascitaPadre ? DateTime.fromFormat(data.dataNascitaPadre, 'yyyyMMdd') : null,
    municipalityBorn: `${data.comuneNascitaPadreDescrizione || ''} ${
      data.provNascitaPadreDescrizione ? `(${data.provNascitaPadreDescrizione})` : ''
    }`,
    municipalityResidence: `${data.comuneResidenzaPadreDescrizione || ''} ${
      data.provResidenzaPadreDescrizione ? `(${data.provResidenzaPadreDescrizione})` : ''
    }`,
  };
};
